$(document).ready(function(){

    // JS for Product Grid set to 3 

   setTimeout(function(){ 
                  var middle_num=jQuery(".grid.product-grid").attr("data-middle-num");
                   
                  jQuery(".grid_box_with_bg").insertBefore(".grid__item[data-number='"+4+"']");
                },100);

 
  

    $('.feature-slider').owlCarousel({
         margin:30,
         loop:true,
         slideSpeed : 5000,
        paginationSpeed : 400,
        // autoplay:true,
        nav:true,
        pagination:false,  dots: false,
        navText: ["<img src='https://cdn.shopify.com/s/files/1/0886/6175/4162/files/prev-arrow-3.png?v=1721101177'>","<img src='https://cdn.shopify.com/s/files/1/0886/6175/4162/files/next-arrow-3.png?v=1721101177'>"],
        responsive:{
            0:{
                items:1
            },
            480:{
                items:1
            },
            700:{
                items:2
            },
            1000:{
                items:3
            },
            1100:{
                items:4
            }
        }
    }); 


  // Faqs Accordion Js

  jQuery(".accordion-heading").click(function(e){
      if(!$(this).closest(".accordion-box").hasClass("open"))
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
      $(this).closest(".accordion-box").find(".accordion_body").slideToggle();
      $(this).closest(".accordion-box").toggleClass("open");
    }
    else
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
    }
  });
     
});


jQuery(document).on("click", '.product__info-wrapper .product-form__submit', function(e) {
    // Check if the "Yes" radio button is selected
    if (jQuery('.customer .recipient-form input[value="yes"]:checked').length > 0) {
        var emailval = jQuery('.email_feild').val(); // Assuming .email_feild is the email input field
        if (emailval === "") {
            e.preventDefault();
            jQuery(".error_msg").text("Please fill out the email field").show();
            setTimeout(function() {
                jQuery(".error_msg").hide();
            }, 4000);
        }
    }
});


